
var stache = require('can/view/stache/stache');
module.exports = stache(" <div class=\"s-item-description\">\r\n    {{#each playerTagGroups}}\r\n        {{#.}}\r\n            <span>{{title}}</span>\r\n        {{/.}}\r\n    {{/each}}\r\n</div>");